module.exports = __webpack_public_path__ + "fonts/TestUntitledSans-Medium.9493acd.woff";